// extracted by css-extract-rspack-plugin
export default {"groupHeaderContainer":"group-header-module__groupHeaderContainer__itDae","groupHeaderContent":"group-header-module__groupHeaderContent__pSEv7"};